import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiCustomerRequestsList, apiCustomerRequestsView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/customerRequests/getData', async datas => {
    const { data } = await apiCustomerRequestsList(datas)
    return data
})

export const getView = createAsyncThunk('admin/customerRequests/getView', async id => {
    const { data } = await apiCustomerRequestsView(id)
    return data
})

export const customerRequestsSlice = createSlice({
    name: 'admin/customerRequests',
    initialState: {
        loading: true,
        view: null,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            term_id: '',
            start: '',
            end: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setTerm: (state, { payload }) => {
            state.table.page = 1
            state.table.term_id = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = null
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setTerm, setDate } = customerRequestsSlice.actions

export default customerRequestsSlice.reducer
